import {
  Button,
  Checkbox,
  Drawer,
  FormControlLabel,
  Grid,
  IconButton,
  Typography,
} from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { memo } from "react";
import LoadingCheckBox from "../../resultadoexercicio/children/LoadingCheckBox";
import { drawersKey } from "../RankingClienteConstants";
import { useRankingClienteService } from "../context/RankingClienteContext";
import CheckSituation from "./Drawer/CheckSituation";

const OriginDrawer = () => {
  const {
    checkedOrigins,
    openedDrawer,
    setDrawerOpen,
    isSituationsLoading,
    handleCheckAllOrigins,
    handleCheckOrigins,
    isOriginIndeterminate,
    clearAllOriginsFilters,
    setOrigins,
  } = useRankingClienteService();

  const handleClose = () => {
    setDrawerOpen(null);
    setOrigins();
  };

  return (
    <Drawer
      open={openedDrawer === drawersKey.origin}
      anchor="right"
      onClose={() => {
        handleClose();
      }}
    >
      <Grid
        container
        direction="column"
        style={{
          width: 480,
          height: "100%",
          maxHeight: "100vh",
          flexWrap: "nowrap",
        }}
      >
        <Grid
          item
          aria-label="drawer-header"
          style={{
            padding: 16,
            borderBottom: "1px solid #dddddd",
            display: "flex",
            alignItems: "center",
            gap: 16,
          }}
        >
          <IconButton
            onClick={() => {
              handleClose();
            }}
            size="small"
          >
            <Close />
          </IconButton>
          <Typography variant="h6"> Origens</Typography>
        </Grid>
        <Grid
          container
          item
          xs
          spacing={2}
          direction="column"
          style={{
            padding: "32px",
          }}
        >
          <Grid item>
            <CheckSituation
              label={`${
                checkedOrigins.every((origin) => origin.checked)
                  ? "Desmarcar"
                  : "Marcar"
              } todos`}
              fullWidth
              disabled={!checkedOrigins.length}
              indeterminate={isOriginIndeterminate}
              checked={checkedOrigins.every((origin) => origin.checked)}
              handleCheck={() =>
                handleCheckAllOrigins(
                  checkedOrigins.some((origin) => !origin.checked)
                )
              }
            />
          </Grid>
          <Grid
            item
            xs
            style={{
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {isSituationsLoading
              ? Array(8)
                  .fill(<LoadingCheckBox />)
                  .map((loadingSkeleton) => loadingSkeleton)
              : checkedOrigins.map((origin) => (
                  <Grid item key={origin.id}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          size="small"
                          checked={origin.checked}
                          onChange={(event) =>
                            handleCheckOrigins(origin, event.target.checked)
                          }
                          name={origin.desc}
                        />
                      }
                      label={origin.desc}
                    />
                  </Grid>
                ))}
          </Grid>
        </Grid>
        <Grid
          item
          style={{
            padding: "16px",
            borderTop: "1px solid #dddddd",
            gap: "16px",
          }}
          container
        >
          <Grid item xs>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={async () => {
                handleClose();
              }}
            >
              Aplicar
            </Button>
          </Grid>
          <Grid item xs>
            <Button
              variant="outlined"
              color="primary"
              fullWidth
              onClick={() => {
                clearAllOriginsFilters();
              }}
            >
              Limpar tudo
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Drawer>
  );
};

export default memo(OriginDrawer);
